import { render, staticRenderFns } from "./questionAdmin.vue?vue&type=template&id=c1a0b744&scoped=true&"
import script from "./questionAdmin.vue?vue&type=script&lang=js&"
export * from "./questionAdmin.vue?vue&type=script&lang=js&"
import style0 from "./questionAdmin.vue?vue&type=style&index=0&id=c1a0b744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a0b744",
  null
  
)

export default component.exports